import { createContext, useContext, useEffect } from 'react';

type SetPageTitle = (title: string | null) => void;

const PageTitleContext = createContext<SetPageTitle>(() => undefined);

export const PageTitleProvider = PageTitleContext.Provider;

export const usePageTitle = (title: string | null | undefined) => {
  const setPageTitle = useContext(PageTitleContext);
  useEffect(() => {
    if (!title) return;
    setPageTitle(title);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
};
